import type { Amar, AmarCategory, WheelOfLifeArea } from '@/core/types/app-state';
import {
    SparklesIcon, HeartIcon, HandThumbUpIcon, ScaleIcon, GiftIcon, StarIcon,
    BenevolenceIcon, MercyIcon, AppreciateIcon, HonorIcon, EcstasyIcon,
    ErosIcon, ExcitementIcon, PlayIcon, DevotionIcon, CommunionIcon,
    BrotherhoodIcon, FriendshipIcon, PencilIcon, TrashIcon, ArrowLeftIcon
} from '@/shared/ui/Icons';

export const AMAR_CATEGORIES: AmarCategory[] = [
    {
        id: 'presence',
        amares: [
            {
                id: 'presence',
                description: 'Estar plenamente en el aquí y el ahora, con atención plena.',
                icon: SparklesIcon,
                color: '#d97706', // amber-600
                tailwindClass: 'text-amber-600',
            },
        ]
    },
    {
        id: 'compasivos',
        amares: [
            {
                id: 'benevolence',
                description: 'Desear sinceramente el bien y la felicidad para los demás.',
                icon: BenevolenceIcon,
                color: '#ec4899', // pink-500
                tailwindClass: 'text-pink-500',
            },
            {
                id: 'compassion',
                description: 'Mostrar amabilidad y comprensión hacia uno mismo y los demás.',
                icon: HeartIcon,
                color: '#f472b6', // pink-400
                tailwindClass: 'text-pink-400',
            },
            {
                id: 'perdon',
                description: 'Liberar el resentimiento para encontrar la paz interior.',
                icon: ScaleIcon,
                color: '#d946ef', // fuchsia-500
                tailwindClass: 'text-fuchsia-500',
            },
            {
                id: 'mercy',
                description: 'Compasión activa ante el sufrimiento, buscando aliviarlo.',
                icon: MercyIcon,
                color: '#c026d3', // fuchsia-600
                tailwindClass: 'text-fuchsia-600',
            },
        ]
    },
    {
        id: 'admirativos',
        amares: [
             {
                id: 'appreciate',
                description: 'Reconocer el valor de las cosas, personas o momentos.',
                icon: AppreciateIcon,
                color: '#22c55e', // green-500
                tailwindClass: 'text-green-500',
            },
            {
                id: 'agradecer',
                description: 'El acto de expresar gratitud, convirtiendo el sentimiento en acción.',
                icon: HandThumbUpIcon, // Re-using for now
                color: '#10b981', // emerald-500
                tailwindClass: 'text-emerald-500',
            },
            {
                id: 'admiration',
                description: 'Reconocer y apreciar la belleza y la excelencia en los demás.',
                icon: StarIcon,
                color: '#84cc16', // lime-500
                tailwindClass: 'text-lime-500',
            },
            {
                id: 'honor',
                description: 'Mostrar respeto y reverencia hacia algo o alguien.',
                icon: HonorIcon,
                color: '#a3e635', // lime-400
                tailwindClass: 'text-lime-400',
            },
             {
                id: 'devotion',
                description: 'Amor profundo y entrega total a una causa, persona o ideal.',
                icon: DevotionIcon,
                color: '#4ade80', // green-400
                tailwindClass: 'text-green-400',
            },
        ]
    },
    {
        id: 'fraternales',
        amares: [
            {
                id: 'communion',
                description: 'Sentimiento de unidad profunda y conexión con otros.',
                icon: CommunionIcon,
                color: '#f59e0b', // amber-500
                tailwindClass: 'text-amber-500',
            },
            {
                id: 'brotherhood',
                description: 'Crear lazos de fraternidad, apoyo y lealtad.',
                icon: BrotherhoodIcon,
                color: '#f97316', // orange-500
                tailwindClass: 'text-orange-500',
            },
            {
                id: 'friendship',
                description: 'Afecto personal, puro y desinteresado, compartido con otra persona.',
                icon: FriendshipIcon,
                color: '#fbbf24', // amber-400
                tailwindClass: 'text-amber-400',
            },
        ]
    },
    {
        id: 'eroticos',
        amares: [
             {
                id: 'ecstasy',
                description: 'Estado de plenitud máxima, gozo y conexión trascendente.',
                icon: EcstasyIcon,
                color: '#ef4444', // red-500
                tailwindClass: 'text-red-500',
            },
            {
                id: 'eros',
                description: 'Amor pasional, impulso vital y creativo.',
                icon: ErosIcon,
                color: '#dc2626', // red-600
                tailwindClass: 'text-red-600',
            },
            {
                id: 'excitement',
                description: 'Agitación emocional intensa, anticipación y energía vital.',
                icon: ExcitementIcon,
                color: '#f87171', // red-400
                tailwindClass: 'text-red-400',
            },
            {
                id: 'play',
                description: 'Disfrutar del momento con ligereza, gozo y sin un fin utilitario.',
                icon: PlayIcon,
                color: '#fb7185', // rose-400
                tailwindClass: 'text-rose-400',
            },
        ]
    },
];

export const ALL_AMARES: Amar[] = AMAR_CATEGORIES.flatMap(category => category.amares);

export const getAmarById = (id: string): Amar | undefined => ALL_AMARES.find(a => a.id === id);

export const WHEEL_OF_LIFE_AREAS: WheelOfLifeArea[] = [
    { id: 'health', color: '#22c55e' }, // green-500
    { id: 'love', color: '#ec4899' }, // pink-500
    { id: 'family', color: '#f97316' }, // orange-500
    { id: 'career', color: '#3b82f6' }, // teal-500
    { id: 'finance', color: '#10b981' }, // emerald-500
    { id: 'personalGrowth', color: '#d97706' }, // amber-600
    { id: 'leisure', color: '#f59e0b' }, // amber-500
    { id: 'environment', color: '#64748b' }, // slate-500
];